import { Application } from '../application/application';
import { XHRDataSource } from '../data-source/xhr-source';
import { XHRResult } from '../xhr/xhr';
import { UTM } from '../map/projection';
import { Datum, SpatialBounds } from '../data-source/types';
import { MultiPointGeometry } from '../modeling/modeling-common';
import { VisualizerControl } from '../data-source/visualizer';
import { TypedDatumDefinition } from '../data-source/types';
import { getPolygonArea, getPolygonCCW } from '../geometry/polygon';
import { Coordinate } from '../map/map-types'
import { GoiDatum } from './poi-common';

let poiDataSource: PoiDataSource = undefined;

export const initializer: { [key: string]: (application: Application) => void } = {
	"poi": (application: Application) => {
		console.log('Initializing poi...');
		poiDataSource = new PoiDataSource(application);
	}
}

export const authenticator: { [key: string]: () => void } = {
}

export const getDataSource = (): PoiDataSource => poiDataSource;

export class PoiDataSource extends XHRDataSource {

	public constructor(application: Application, type?: string) {
		super({
			name: 'poi',
			url: `/${encodeURI(application.getDomain())}/poi/selection/goi`,
			query: '&active=true&deleted=false'+(type ? '&types=' + type : ''),
		}, application);
		super.addType({ id: 'any',   label: 'Geometry Of Interest', icon: 'icon-location' },undefined);
	}
	
	public setControls(controls: VisualizerControl): string {
		return this.setVisualizerControlForType(this.getTypes()[0], controls);
	}

//the following methods need to be overriden when the data source is a single type source	
	public addType(type: TypedDatumDefinition, controls: VisualizerControl): string {
		return this.getTypes()[0];
	}

	public removeType(typeId: string): void {
	}

	protected getDatumType( datum:any ): string {
		return this.getTypes()[0];
	}


	/**
	 * Gets called just before the data is stored in source's storage
	 * Override if some data processing is requiered 
	 */
	protected processResponse(response: XHRResult): any {
		let data = <GoiDatum[]>response.data;
		if (data && data.length > 0) {
			//N.B.!! we make the assumption that all geometries of interest comming from an atlas lie in the same UTM zone
			
			//due to a bug in the poi editor, a poi can miss the geometry property (or it is empty) we need to check for that
			data  = data.filter(datum => datum  && datum.geometry && (datum.geometry.lat!==undefined || (<MultiPointGeometry>datum.geometry).coordinates.length > 0));
			

			//this is a hack because the old implementation did not hold fields for
			//properties like color or if the goi was to be considered as a 'hole'
			//in the grid etc.
			//the name properties is abused now to have so called meta data between curly
			//brackets. This constructs captures the meta tags and the actual name to
			//be displayed
			const metaExpr = new RegExp("{([^}]+)}", "g");
			const nameExpr = new RegExp("[^}]*$", "g");
			
			let datum = data[0];
			let utm: UTM = datum?.geometry.lat!==undefined ? UTM.get(datum.geometry.lat, datum.geometry.lng) : UTM.get((<MultiPointGeometry>datum.geometry).coordinates[0].lat, (<MultiPointGeometry>datum.geometry).coordinates[0].lng);

			//calculate the utm coordinates and bounds
			for (let i = 0; i < data.length; i++) {
				const isArea = !!(<MultiPointGeometry>data[i].geometry).coordinates;
				const meta = Array.from((<string>data[i].name).matchAll(metaExpr)).map(
				  (match) => match[1]
				);
				const nameMatch = (<string>data[i].name).match(nameExpr);
				const name = nameMatch ? nameMatch[0] : "";

				const isHole =
				  meta.filter((property) => property.toLowerCase() === "hole")
				    .length === 1 && isArea;
				const metaColors = meta
				  .filter((property) => property.startsWith("#"))
//				  .map((colorProperty) => okhsl(colorProperty));
				const metaColor = metaColors.length > 0 ? metaColors[0] : undefined;
				const restMeta = meta.filter(
				  (property) =>
				    property.toLowerCase() !== "hole" || property.startsWith("#")
				);

                data[i].name = name;
                data[i].isHole = isHole;
                data[i].color = metaColor;
                data[i].meta = restMeta;

				
				
				if ((<MultiPointGeometry>data[i].geometry).coordinates) {
					let multiPointGeometry = <MultiPointGeometry>data[i].geometry;
					data[i].geometry.xy = multiPointGeometry.coordinates.map(coord => 
					utm.toCartesian(coord.lat, coord.lng)
					);
					
					data[i].geometry.xy = getPolygonCCW(<Coordinate[]>data[i].geometry.xy);

                    data[i].size = getPolygonArea(<Coordinate[]>data[i].geometry.xy );

					multiPointGeometry.coordinates.reduce((bounds, coordinate) => {
						bounds.north = bounds.north === undefined ? coordinate.lat : Math.max(coordinate.lat, bounds.north);
						bounds.south = bounds.south === undefined ? coordinate.lat : Math.min(coordinate.lat, bounds.south);
						bounds.east = bounds.east === undefined ? coordinate.lng : Math.max(coordinate.lng, bounds.east);
						bounds.west = bounds.west === undefined ? coordinate.lng : Math.min(coordinate.lng, bounds.west);
						return bounds;
					}, <SpatialBounds>data[i]);
				} else {
					data[i].geometry.xy = utm.toCartesian(data[i].geometry.lat, data[i].geometry.lng);
					data[i].lat = data[i].geometry.lat;
					data[i].lng = data[i].geometry.lng;
					data[i].north = data[i].geometry.lat;
					data[i].east = data[i].geometry.lng;
					data[i].south = data[i].geometry.lat;
					data[i].west = data[i].geometry.lng;
                    data[i].size = 0.0;
				}

			}
		}

		return data;

	}

}
